function Madeira({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1563)">
  <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5068 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5068 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#FFDA44"/>
  <path d="M9.0435 1.58789C3.69156 4.17583 0 9.65639 0 15.9997C0 22.343 3.69156 27.8236 9.0435 30.4115V1.58789Z" fill="#0052B4"/>
  <path d="M22.9565 1.58789V30.4115C28.3084 27.8236 32 22.343 32 15.9997C32 9.65639 28.3084 4.17583 22.9565 1.58789Z" fill="#0052B4"/>
  <path d="M20.5218 17.3911L21.5652 18.7824V13.2171L20.5218 14.6084H17.3913V11.478L18.7826 10.4346H13.2174L14.6087 11.478V14.6084H11.4783L10.4348 13.2171V18.7824L11.4783 17.3911H14.6087V20.5215L13.2174 21.5649H18.7826L17.3913 20.5215V17.3911H20.5218Z" fill="#D80027"/>
  <path d="M20.1739 15.3045H16.6956V11.8262H15.3044V15.3045H11.826V16.6957H15.3044V20.174H16.6956V16.6957H20.1739V15.3045Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Madeira;
